var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2.8125C5.58274 2.8125 2.8125 5.58274 2.8125 9C2.8125 9.79646 2.9627 10.5565 3.23581 11.2543C3.37728 11.6157 3.447 12.0294 3.37579 12.4522L2.93594 15.0641L5.54778 14.6242C5.9706 14.553 6.38431 14.6227 6.74574 14.7642C7.44351 15.0373 8.20354 15.1875 9 15.1875C12.4173 15.1875 15.1875 12.4173 15.1875 9C15.1875 5.58274 12.4173 2.8125 9 2.8125ZM1.6875 9C1.6875 4.96142 4.96142 1.6875 9 1.6875C13.0386 1.6875 16.3125 4.96142 16.3125 9C16.3125 13.0386 13.0386 16.3125 9 16.3125C8.06098 16.3125 7.16201 16.1352 6.3357 15.8118C6.12432 15.7291 5.91836 15.7026 5.73461 15.7336L2.86298 16.2172C2.22732 16.3242 1.67576 15.7727 1.78281 15.137L2.26641 12.2654C2.29736 12.0816 2.27093 11.8757 2.1882 11.6643C1.86478 10.838 1.6875 9.93902 1.6875 9Z",
    fill: "#818181"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4375 7.49976C5.4375 7.1891 5.68934 6.93726 6 6.93726H12C12.3107 6.93726 12.5625 7.1891 12.5625 7.49976C12.5625 7.81042 12.3107 8.06226 12 8.06226H6C5.68934 8.06226 5.4375 7.81042 5.4375 7.49976ZM5.4375 10.4998C5.4375 10.1891 5.68934 9.93726 6 9.93726H9C9.31066 9.93726 9.5625 10.1891 9.5625 10.4998C9.5625 10.8104 9.31066 11.0623 9 11.0623H6C5.68934 11.0623 5.4375 10.8104 5.4375 10.4998Z",
    fill: "#818181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.4c012df7f3d5dac059310b3a3f6e583b.svg";
export { ForwardRef as ReactComponent };